import React from "react";
import * as RB from "react-bootstrap";
import { Link } from "react-router-dom";

function View(props) {
  const { rowData, onBackClick } = props;

  return (
    <>
      <div className="section-body">
        <RB.Card className="card shadow">
          <RB.Card.Header className="border-0">
            <h5>View</h5>
            <div className="card-header-action">
              <Link className="btn btn-underline me-2" onClick={onBackClick}>
                Back
              </Link>
            </div>
          </RB.Card.Header>
          <RB.Card.Body>
            {/* Basic Details */}
            <RB.Row className="mb-3">
              <RB.Col md={3}>
                <span className="text-uppercase fw-bold small text-body-secondary">
                  Move Order No
                </span>
                <p className="fw-medium text-sm fw-semibold">
                  {rowData.move_order_no || "-"}
                </p>
              </RB.Col>
              <RB.Col md={3}>
                <span className="text-uppercase fw-bold small text-body-secondary">
                  Move Order Date
                </span>
                <p className="fw-medium text-sm fw-semibold">
                  {rowData.move_order_date || "-"}
                </p>
              </RB.Col>

              <RB.Col md={3}>
                <span className="text-uppercase fw-bold small text-body-secondary">
                  Plant (Move From)
                </span>
                <p className="fw-medium text-sm fw-semibold">
                  {props.rowData.plant_name || "-"}
                </p>
              </RB.Col>
              <RB.Col md={3}>
                <span className="text-uppercase fw-bold small text-body-secondary">
                  Plant (Move To)
                </span>
                <p className="fw-medium text-sm fw-semibold">
                  {props.rowData.plant_to || "-"}
                </p>
              </RB.Col>
              <RB.Col md={3}>
                <span className="text-uppercase fw-bold small text-body-secondary">
                  Location (Move From)
                </span>
                <p className="fw-medium text-sm fw-semibold">
                  {props.rowData.location_name || "-"}
                </p>
              </RB.Col>
              <RB.Col md={3}>
                <span className="text-uppercase fw-bold small text-body-secondary">
                  Location (Move To)
                </span>
                <p className="fw-medium text-sm fw-semibold">
                  {props.rowData.location_to || "-"}
                </p>
              </RB.Col>

              <RB.Col md={3}>
                <span className="text-uppercase fw-bold small text-body-secondary">
                  Name Of Equipment
                </span>
                <p className="fw-medium text-sm fw-semibold">
                  {props.rowData.equipment_name || "-"}
                </p>
              </RB.Col>
              <RB.Col md={3}>
                <span className="text-uppercase fw-bold small text-body-secondary">
                  Make / Brand
                </span>
                <p className="fw-medium text-sm fw-semibold">
                  {props.rowData.brand || "-"}
                </p>
              </RB.Col>
              <RB.Col md={3}>
                <span className="text-uppercase fw-bold small text-body-secondary">
                  Asset Model / Type
                </span>
                <p className="fw-medium text-sm fw-semibold">
                  {props.rowData.assets_type || "-"}
                </p>
              </RB.Col>
              <RB.Col md={3}>
                <span className="text-uppercase fw-bold small text-body-secondary">
                  No of Equipments
                </span>
                <p className="fw-medium text-sm fw-semibold">
                  {props.rowData.no_of_equipments || "-"}
                </p>
              </RB.Col>

              <RB.Col md={3}>
                <span className="text-uppercase fw-bold small text-body-secondary">
                  Asset Code No.
                </span>
                <p className="fw-medium text-sm fw-semibold">
                  {props.rowData.asset_code_no || "-"}
                </p>
              </RB.Col>
              <RB.Col md={3}>
                <span className="text-uppercase fw-bold small text-body-secondary">
                  Asset Tag No.
                </span>
                <p className="fw-medium text-sm fw-semibold">
                  {props.rowData.asset_tag_no || "-"}
                </p>
              </RB.Col>
              <RB.Col md={3}>
                <span className="text-uppercase fw-bold small text-body-secondary">
                  Supplier Name
                </span>
                <p className="fw-medium text-sm fw-semibold">
                  {props.rowData.supplier_name || "-"}
                </p>
              </RB.Col>
              <RB.Col md={3}>
                <span className="text-uppercase fw-bold small text-body-secondary">
                  CER No.
                </span>
                <p className="fw-medium text-sm fw-semibold">
                  {props.rowData.cer_no || "-"}
                </p>
              </RB.Col>

              <RB.Col md={3}>
                <span className="text-uppercase fw-bold small text-body-secondary">
                  PO No.
                </span>
                <p className="fw-medium text-sm fw-semibold">
                  {props.rowData.po_no || "-"}
                </p>
              </RB.Col>
              <RB.Col md={3}>
                <span className="text-uppercase fw-bold small text-body-secondary">
                  PO Date
                </span>
                <p className="fw-medium text-sm fw-semibold">
                  {props.rowData.po_date || "-"}
                </p>
              </RB.Col>
              <RB.Col md={3}>
                <span className="text-uppercase fw-bold small text-body-secondary">
                  Commencement Date
                </span>
                <p className="fw-medium text-sm fw-semibold">
                  {props.rowData.production_capitalisation_date || "-"}
                </p>
              </RB.Col>
              <RB.Col md={3}>
                <span className="text-uppercase fw-bold small text-body-secondary">
                  Special Benefits
                </span>
                <p className="fw-medium text-sm fw-semibold">
                  {props.rowData.benefits_classification_category || "-"}
                </p>
              </RB.Col>

              <RB.Col md={3}>
                <span className="text-uppercase fw-bold small text-body-secondary">
                  Useful Life of Assets
                </span>
                <p className="fw-medium text-sm fw-semibold">
                  {props.rowData.useful_life_assets || "-"}
                </p>
              </RB.Col>
              <RB.Col md={3}>
                <span className="text-uppercase fw-bold small text-body-secondary">
                  Asset Book Value
                </span>
                <p className="fw-medium text-sm fw-semibold">
                  {props.rowData.assets_book_value || "-"}
                </p>
              </RB.Col>
              <RB.Col md={3}>
                <span className="text-uppercase fw-bold small text-body-secondary">
                  Capitalisation Entry No.
                </span>
                <p className="fw-medium text-sm fw-semibold">
                  {props.rowData.capitalistion_entry_no || "-"}
                </p>
              </RB.Col>
              <RB.Col md={3}>
                <span className="text-uppercase fw-bold small text-body-secondary">
                  Capitalisation Date
                </span>
                <p className="fw-medium text-sm fw-semibold">
                  {props.rowData.capitalistion_date || "-"}
                </p>
              </RB.Col>

              <RB.Col md={3}>
                <span className="text-uppercase fw-bold small text-body-secondary">
                  FAR Serial No.
                </span>
                <p className="fw-medium text-sm fw-semibold">
                  {props.rowData.FAR_serial_no || "-"}
                </p>
              </RB.Col>
              <RB.Col md={3}>
                <span className="text-uppercase fw-bold small text-body-secondary">
                  Attachment
                </span>
                <div className="fw-medium text-sm fw-semibold">
                  {rowData.attechPath ? (
                    <a
                      href={rowData.attechPath}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img
                        src={rowData.attechPath}
                        alt="Attachment"
                        style={{
                          maxWidth: "100%",
                          maxHeight: "200px",
                          height: "auto",
                          cursor: "pointer",
                        }}
                      />
                    </a>
                  ) : (
                    "-"
                  )}
                </div>
              </RB.Col>
            </RB.Row>

            <h6>Invoice Data</h6>
            <RB.Table striped bordered hover responsive>
              <thead>
                <tr>
                  <th>#</th>
                  <th>Supplier Name</th>
                  <th>Bill No</th>
                  <th>Date</th>
                  <th>Quantity</th>
                  <th>Amount</th>
                </tr>
              </thead>
              <tbody>
                {rowData?.invoice_data?.map((item, index) => (
                  <tr key={item.id}>
                    <td>{index + 1}</td>
                    <td>{item.supplier_name}</td>
                    <td>{item.bill_no}</td>
                    <td>{item.date}</td>
                    <td>{item.qty}</td>
                    <td>{item.amount}</td>
                  </tr>
                ))}
              </tbody>
            </RB.Table>
          </RB.Card.Body>
        </RB.Card>
      </div>
    </>
  );
}

export default View;
